import { render, staticRenderFns } from "./EModalHighlightsJornada.vue?vue&type=template&id=2d49992f&scoped=true"
import script from "./EModalHighlightsJornada.vue?vue&type=script&lang=js"
export * from "./EModalHighlightsJornada.vue?vue&type=script&lang=js"
import style0 from "./EModalHighlightsJornada.vue?vue&type=style&index=0&id=2d49992f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49992f",
  null
  
)

export default component.exports